import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { tagQueryKeys } from './tagsQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { useWoody } from '../../woody/woody.js';

const useQueryResourceTags = (resourceId, queryOptions) => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const query = useQuery({
    queryKey: tagQueryKeys.resources(resourceId ? [
      resourceId
    ] : []),
    queryFn: async (params) => {
      const resourceId2 = params.queryKey[1][0];
      if (resourceId2 === "draft") {
        return [];
      }
      const { resources } = await client.v2("/v2/resource-tag-private/lookup", {
        method: "post",
        body: {
          resourceIds: [
            resourceId2
          ]
        }
      });
      return resources;
    },
    placeholderData: keepPreviousData,
    refetchInterval: 45e3,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!resourceId,
      !!user,
      queryOptions?.enabled
    ])
  });
  return {
    ...query,
    data: query.data?.find((item) => item.id === resourceId)?.tags || []
  };
};
const useQueryMultipleResourceTags = (resourceIds, queryOptions) => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const query = useQuery({
    queryKey: tagQueryKeys.resources(resourceIds),
    queryFn: async (params) => {
      const resourceIds2 = params.queryKey[1];
      const { resources } = await client.v2("/v2/resource-tag-private/lookup", {
        method: "post",
        body: {
          resourceIds: resourceIds2
        }
      });
      for (const resourceId of resourceIds2) {
        if (!resources.find((r) => r.id === resourceId)) {
          resources.push({
            id: resourceId,
            tags: []
          });
        }
      }
      return resources;
    },
    placeholderData: keepPreviousData,
    refetchInterval: 45e3,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!resourceIds && resourceIds.length > 0,
      !!user,
      queryOptions?.enabled
    ])
  });
  return query;
};

export { useQueryMultipleResourceTags, useQueryResourceTags };
//# sourceMappingURL=useQueryResourceTags.js.map
